<template>
    <div >
        <meisterschaft-runde-aktionen :runde="runde"
                                      :bewerb="bewerb"
                                      :landesverband-id="landesverbandId"
                                      @refresh="refreshBewerb"
                                      @addTeam="editTeam"
                                      @editSettings="editSettings"/>
        <meisterschaft-runde-tab v-if="runde.settings.modus === 'tabelle'"
                                 :runde="runde"
                                 :bewerb="bewerb"
                                 class="pb-5"
                                 :landesverband-id="landesverbandId"
                                 @editTeam="editTeam"
                                 @editRundeTabResult="editRundeTabResult"
                                 @refreshBewerb="refreshBewerb"/>
        <meisterschaft-runde-ko v-else :runde="runde"
                                class="pb-5"
                                :dauer-geplant="bewerb?.settings?.spiel?.dauerGeplant"
                                :team-label="teamLabel"
                                :landesverband-id="landesverbandId"
                                :bewerb-is-confirmed="bewerb.isConfirmed()"
                                @refreshBewerb="refreshBewerb"
                                @editTeam="editTeamSpiel"
                                @editSpielResult="editSpielResult"
                                @confirmClearSpiel="confirmClearSpiel"/>
    </div>
</template>

<script>
import MeisterschaftRundeTab from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRundeTab.vue";
import MeisterschaftRundeKo from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRundeKo.vue";
import MeisterschaftRundeAktionen from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRundeAktionen.vue";

export default {
    name: "meisterschaftRunde",
    components: {MeisterschaftRundeAktionen, MeisterschaftRundeKo, MeisterschaftRundeTab},
    props: ['runde', 'bewerb', 'landesverbandId'],
    computed: {
        teamLabel(){ return this.bewerb.getTeamLabel() },
    },
    methods: {
        editTeam(team){
            this.$emit('editTeam', {action: 'editMeisterschaftTeam', runde: this.runde, team: team});
        },
        editTeamSpiel(params){
            this.$emit('editTeam', {action: 'editMeisterschaftTeam', runde: this.runde,
                                              team: params.team, spiel: params.spiel});
        },
        editRundeTabResult(team){
            this.$emit('editResult', {action: 'editRundeTabResult', runde: this.runde, team: team});
        },
        editSettings(){
            this.$emit('editSettings', {action: 'editRundeSettings', runde: this.runde});
        },
        refreshBewerb(){
            this.$emit('refreshBewerb', this.runde.settings.bewerbTyp);
        },
        editSpielResult(spiel){
            this.$emit('editSpielResult', spiel);
        },
        confirmClearSpiel(params){
            this.$emit('confirmClearSpiel', params);
        }
    },
}
</script>

<style scoped>

</style>